/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from 'components/Fields/Input';

import { useSpecSheet } from 'containers/spec-sheet';
import { useDebounce } from 'hooks/useDebounce';

const Construction: React.FC = () => {
  const {
    data: { data },
    actions,
  } = useSpecSheet();

  const construction = data?.construction || '';

  const [value, setValue] = useState(construction);

  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setValue(value);
  };

  const saveChange = async () =>
    actions.changeSpecSheetData({ construction: value.trim() });

  const autoSave = useDebounce(value);

  const handleSave = () => {
    if (construction !== value) saveChange();
  };

  useEffect(() => {
    handleSave();
  }, [autoSave]);

  const isCompleted = !!value;

  return (
    <Input
      label="Construction"
      value={value}
      name="Construction"
      onChange={handleChange}
      dataTest="Construction"
      isCompleted={isCompleted}
      handleBlur={() => handleSave()}
      placeholder="Click to add"
    />
  );
};

export default Construction;
